import { ToolConfig } from "../types/ToolConfig";

export const HR_TOOLS: ToolConfig[] = [
 {
   name: "Modify Org Representative",
   description: "Allows administrators to modify/update assigned POC for Staff & Driver's at an organization",
   requiredRoles: ["HRConfigMgt.Engauge"],
 },
 {
   name: "Modify Worksite Representative",
   description: "Allows administrators to modify/update assigned POC for Staff & Driver's at a specified worksite",
   requiredRoles: ["HRConfigMgt.Engauge"],
 },
 {
   name: "Driver Supervisor Mapping",
   description: "Allows administrators to assign or update the supervisor responsible for a fleet code.",
   requiredRoles: ["HRConfigMgt.Engauge"],
 },
 {
   name: "Yellow Marked Employees",
   description: "Allows administrators to display employees marked with a yellow status to diagnose and resolve",
   requiredRoles: ["HRConfigMgt.EngaugeBeta"],
 },
 {
   name: "Termination Workflow Request",
   description: "Allows administrators to modify an employee's expected last date of work",
   requiredRoles: ["HRConfigMgt.Engauge"],
 },
];